import { createSvgIcon } from "@mui/material/utils"
import * as React from "react"

export const IcInfo = createSvgIcon(
	<svg fill="currentColor" width="24" height="24" viewBox="0 0 24 24">
		<path d="M13.25 7c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25.56-1.25 1.25-1.25 1.25.56 1.25 1.25zm10.75 5c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-2 0c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10 10-4.486 10-10zm-13-2v2h2v6h2v-8h-4z" />
	</svg>,
	"IcInfo"
)
